import React from 'react'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { useHistory, useLocation, useParams } from 'react-router'
import { AssetTransferByDepartmentDetailContent } from './AssetTransferByDepartmentDetailContent'

export const AssetTransferByDepartmentDetail = () => {
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/asset-transfer-by-department`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Asset Transfer By Department', current: true },
        ]}
        rightRouteSegments={[{ name: 'Detail', current: true }]}
      />
      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{editData?.Asset?.name}</span>
          </span>
        }
        rightText={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{editData?.DocNo}</span>
          </span>
        }
        infoLine={
          <>
            <div className="text-overflow" style={{ paddingBottom: '4px' }}>
              From: {editData?.FromDepartment?.Name}
            </div>
            <div className="text-overflow">
              To: {editData?.ToDepartment?.Name}
            </div>
          </>
        }
        rightInfoLine={<span>{formatDate(editData?.transfer_date)}</span>}
      />
      <ContentWrapper multiDynamicInfo float>
        <CardContents
          section={{
            header: { title: 'Transfer Information' },
          }}
        >
          <AssetTransferByDepartmentDetailContent
            listEl={editData}
            listStatus={editData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
